const LOCAL_BACKEND_URL = "http://localhost:8000";

const isLocalFrontend = () => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

const normalizeUrl = (value) => value.replace(/\/$/, "");

const isValidAbsoluteUrl = (value) => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

const resolveSameOriginBackendUrl = () => {
  if (typeof window === "undefined") return "";

  const { origin, hostname } = window.location;

  if (isLocalFrontend()) {
    return LOCAL_BACKEND_URL;
  }

  if (hostname === "metalconcrete.com" || hostname === "www.metalconcrete.com") {
    return "https://api.metalconcrete.com";
  }

  return origin;
};

export const resolveBackendUrl = () => {
  const candidate = (
    process.env.REACT_APP_BACKEND_URL ||
    process.env.BACKEND_URL ||
    ""
  ).trim();

  if (candidate) {
    if (isValidAbsoluteUrl(candidate)) {
      return normalizeUrl(candidate);
    }

    console.error(`[api] Backend URL has an invalid value: "${candidate}"`);
  }

  const fallbackUrl = resolveSameOriginBackendUrl();

  if (fallbackUrl) {
    console.warn(
      "[api] Backend URL env is missing or invalid. Falling back to runtime origin resolution.",
    );
    return normalizeUrl(fallbackUrl);
  }

  console.error(
    "[api] Backend URL could not be resolved from environment or runtime origin.",
  );
  return "";
};

const normalizedBackendUrl = resolveBackendUrl();

export const BACKEND_URL = normalizedBackendUrl;
export const API_BASE_URL = `${BACKEND_URL}/api`;
